module.exports = __webpack_public_path__ + "application/templates/login/login.template.html";